module.exports = __webpack_public_path__ + "static/media/Internationalcase6.182d8e0d.png";